import * as React from 'react'
import { Link } from 'react-router-dom'

import * as Breadcrumbs from '@espoon-voltti/react-components/components/breadcrumb'

export interface BreadcrumbRoute {
  dataQa?: string
  label: React.ReactNode
  link: string
}

interface Props {
  route: BreadcrumbRoute[]
}

export const Breadcrumb = ({ route }: Props) => {
  return (
    <Breadcrumbs.Breadcrumbs>
      {route.map((r) => (
        <Breadcrumbs.Breadcrumb
          active={r.link === '#'}
          key={r.link}
          dataQa={r.dataQa}
        >
          <Link to={r.link}>{r.label}</Link>
        </Breadcrumbs.Breadcrumb>
      ))}
    </Breadcrumbs.Breadcrumbs>
  )
}
